import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Gamepad2, Store, Users } from "lucide-react"; // 'Steam' cserélve 'Gamepad2'-re
import { useAuth } from "@/context/AuthContext";

interface GameLinksBoxProps {
  game: {
    id: number;
    link_steam?: string;
    developer?: string;
    developerWebsiteLink?: string;
    link_other?: string;
    link_epic?: string;
    link_hun?: string;
  };
}

const GameLinksBox: React.FC<GameLinksBoxProps> = ({ game }) => {
  const { isEgame } = useAuth(); // Feltételezzük, hogy van ilyen a kontextusban

  const handleTrackedClick = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const url = e.currentTarget.href;
    const csrfToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content;

    try {
      await fetch(`/api/statistics/egame_click/${game.id}`, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': csrfToken || '',
        },
      });
    } catch (error) {
      console.error("Kattintás követése sikertelen:", error);
    } finally {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <Card className="bg-gray-800 text-secondary-foreground border-border shadow-md">
      <CardHeader>
        <CardTitle className="text-xl font-bold text-primary">Linkek</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-3">
        {game.link_steam && (
          <Button variant="outline" className="w-full justify-start bg-muted text-muted-foreground border-border hover:bg-primary hover:text-primary-foreground" asChild>
            <a href={game.link_steam} target="_blank" rel="noopener noreferrer">
              <Gamepad2 size={16} className="mr-2" /> Steam »
            </a>
          </Button>
        )}
        {game.link_hun && (
          <Button variant="outline" className="w-full justify-start bg-muted text-muted-foreground border-border hover:bg-primary hover:text-primary-foreground" asChild>
            <a href={game.link_hun} onClick={handleTrackedClick}>
              <span role="img" aria-label="Magyar zászló" className="mr-2">🇭🇺</span> Magyaritasok.hu »
            </a>
          </Button>
        )}
        {game.link_epic && (
          <Button variant="outline" className="w-full justify-start bg-muted text-muted-foreground border-border hover:bg-primary hover:text-primary-foreground" asChild>
            <a href={game.link_epic} target="_blank" rel="noopener noreferrer">
              <Store size={16} className="mr-2" /> Epic »
            </a>
          </Button>
        )}
        {game.link_other && (
          <Button
            variant="outline"
            className="w-full justify-start bg-muted text-muted-foreground border-border hover:bg-primary hover:text-primary-foreground"
            asChild
          >
            <a href={game.link_other} target="_blank" rel="noopener noreferrer">
              <Gamepad2 size={16} className="mr-2" />
              {(() => {
                try {
                  const url = new URL(game.link_other);
                  const domainParts = url.hostname.replace(/^www\./, '').split('.');
                  const domainName = domainParts[0].charAt(0).toUpperCase() + domainParts[0].slice(1);
                  return `${domainName} »`;
                } catch (e) {
                  return game.link_other; // fallback
                }
              })()}
            </a>
          </Button>
        )}
        {game.developer && game.developerWebsiteLink && (

          <Button variant="outline"
            className="w-full justify-start bg-muted text-muted-foreground border-border hover:bg-primary hover:text-primary-foreground"
            asChild
          >
            <a href={game.developerWebsiteLink} target="_blank" rel="noopener noreferrer">
              <Users size={16} className="mr-2" /> Fejlesztők
            </a>
          </Button>
        )}
      </CardContent>
    </Card>
  );
};

export default GameLinksBox;